var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c(_setup.SkeletonLoader,{staticClass:"home-hero-loader"},[_c('div',{staticClass:"home-hero-loader__primary"}),_c('div',{staticClass:"home-hero-loader__primary-secundary"}),_c('div',{staticClass:"home-hero-loader__primary-secundary"})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }